import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import composeIcon from '@lifesize/ux-assets/vectors/svgIcons/compose.svg';
import ChatListGroups from 'components/Chat/ChatListGroups/ChatListGroups';
import classes from './ChatList.module.scss';

export const ChatList = (props) => {
  const { onStartNewChat } = props;

  return (
    <div className={classes.chatListContainer}>
      <div className={classes.chatListHeader}>
        <div className={classes.chatListHeaderTitle}>
          <FormattedMessage
            id="components.chat.chatListHeader"
            description="Label for the chat meetings and contacts lists header"
            defaultMessage="Chats"
          />
        </div>
        <button
          className={classes.chatListHeaderButton}
          onClick={onStartNewChat}
          type="button"
          data-testid="start-new-chat-hdr-btn"
        >
          <SVG src={composeIcon} data-testid="composeIcon" />
        </button>
      </div>
      <ChatListGroups
        {...props}
      />
    </div>
  );
};


ChatList.propTypes = {
  onStartNewChat: PT.func
};

export default ChatList;
